import React from 'react';
import PropTypes from 'prop-types';
import FacilityFrameOfferAssetClientComponent from './FacilityFrameOfferAssetClientComponent';
import OfferAssetClientSummary from './OfferAssetClientSummary';
import { Grid } from '@mui/material';
import Mail from '@mui/icons-material/Mail';
import { CollapseCard, Autocomplete } from '@totalsoft/rocket-ui';

import { withTranslation } from 'react-i18next';
import { withRights } from 'providers/RightsConsumer';

export const FacilityFrameOfferAssetClientCard = ({
  client,
  clientDataSummary,
  isDirty,
  expanded,
  saving,
  validationInfo,
  onSave,
  onPropertyChange,
  onCardToggle,
  t,
  partnerTypes,
  rights,
  defaultPartnerType,
  loadLegalPartners,
  partnerType,
  onUniqueIdBlur,
  setIsPartnerFromModal,
  legalForms,
  isClientLoaded,
  offerForCompanies
}) => {
  return (
    <CollapseCard
      id={'offerAssetClientCard'}
      icon={Mail}
      iconColor='primary'
      title={t('OfferEdit.Client.ClientData')}
      expanded={expanded}
      onToggle={(_, expanded) => onCardToggle(_, !expanded)}
      subheader={<OfferAssetClientSummary clientDataSummary={clientDataSummary} isClientLoaded={isClientLoaded} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={6}>
          <Autocomplete
            id={'offerAssetClientCard_partnerType'}
            disabled={rights.readOnlyFull || !offerForCompanies}
            fullWidth
            value={client.partnerType || defaultPartnerType}
            valueKey='partnerTypeId'
            labelKey='partnerTypeName'
            label={t('OfferEdit.Client.PartnerType')}
            options={partnerTypes}
            onChange={onPropertyChange('partnerType')}
            isClearable={false}
          />
        </Grid>
        {client.partnerType && partnerType && (
          <FacilityFrameOfferAssetClientComponent
            client={client}
            isClientLoaded={isClientLoaded}
            validationInfo={validationInfo}
            isDirty={isDirty}
            onSave={onSave}
            saving={saving}
            onPropertyChange={onPropertyChange}
            onUniqueIdBlur={onUniqueIdBlur}
            partnerTypeCode={client.partnerType?.partnerTypeCode}
            partnerTypeId={client.partnerType?.partnerTypeId}
            loadLegalPartners={loadLegalPartners}
            setIsPartnerFromModal={setIsPartnerFromModal}
            isPJ={partnerType.typeCheck.isPJ}
            legalForms={legalForms}
          />
        )}
      </Grid>
    </CollapseCard>
  );
};

FacilityFrameOfferAssetClientCard.propTypes = {
  client: PropTypes.object.isRequired,
  clientDataSummary: PropTypes.object.isRequired,
  validationInfo: PropTypes.object.isRequired,
  isDirty: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onUniqueIdBlur: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  onCardToggle: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  defaultPartnerType: PropTypes.object.isRequired,
  partnerTypes: PropTypes.array.isRequired,
  partnerType: PropTypes.object.isRequired,
  loadLegalPartners: PropTypes.func.isRequired,
  setIsPartnerFromModal: PropTypes.func.isRequired,
  legalForms: PropTypes.array.isRequired,
  isClientLoaded: PropTypes.bool.isRequired,
  offerForCompanies: PropTypes.bool.isRequired
};

export default withTranslation()(withRights(FacilityFrameOfferAssetClientCard));
